// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "LogoMakerLPLazyComponent" + "." + "27bbf169bc988ab7406a" + ".js";
};